<template>
       <div>
          <div data-v-951e5bd4="" class="price_title">会员专属价格</div>
          <el-row>
            <el-col :span="24" class="title " >
              <div v-for="(item, index) in awardName" :key="index">
                <span class="tname">{{ item.name }} </span>
              </div>
              <!-- <span style="margin-left:100px">仓库名称</span> -->
            </el-col>
          </el-row>
          <el-row >
            <el-col :span="24" v-for="(item, index) in gridData" :key="index"  data-v-f3f3eg9>
              <div class=" price" data-v-f3f3eg9>
                <span class="itempic" v-if="vipName == '普通会员' " style="color:red"> {{item.price0}} </span>
                <span class="itempic" v-else> {{item.price0}} </span>
                <span class="itempic" v-if="vipName == '金牌会员' " style="color:red">{{item.price1}}</span>
                <span class="itempic" v-else>{{item.price1}}</span>
                <span class="itempic" v-if="vipName == '至尊会员' " style="color:red">{{item.price2}}</span>
                <span class="itempic" v-else>{{item.price2}}</span>
                <span class="itempic" v-if="vipName == '大客户vip' " style="color:red"> {{item.price3}}</span>
                <span class="itempic" v-else> {{item.price3}}</span>
                <span class="itempic">{{item.storage_name}}</span>
              </div>
            </el-col>
          </el-row>
        </div>
</template>

<script>
import { deliverPrice, getAward } from 'network/api'

export default {
  data() {
    return {
      gridData: [],
      awardName: null,
      vip: '无',
      kehu: 'null',
      vipName: ''
    }
  },
  created() {
    this.$emit('vipName', this.vipName)
    getAward().then((res) => {
      if (res.code !== 1) return
      this.awardName = res.data
      res.data.forEach((item) => {
        this.vipName = item.name
      })
    })
    deliverPrice().then((res) => {
      if (res.code === 1) {
        this.gridData = res.data
      }
    })
  },
  methods: {
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex === 1) {
        return 'warning-row'
      } else if (rowIndex === 3) {
        return 'success-row'
      }
    }
  }
}
</script>

<style scoped lang="scss">
.price .title {
  display: flex;
}
.price{
  line-height: 48px;
}
.price:hover{
  background-color: #eaeaea;
}
.title {
  display: flex;
  background-color: #f5f7fa;
  font-size: 16px;
  line-height: 50px;
  white-space: nowrap;
}
.tname {
  font-size: 18px;
  margin: 0 65px 0 0;
  margin-left: 60px;
}
.itempic {
  font-size: 16px;
  margin: 0 80px;
  padding: 6px 0px;
}
// .el-row[data-v-f03b86ff] {
//   margin-bottom: 20px;
//   min-height: 600px;
//   max-height: 678px;
//   overflow: auto;
//   white-space: nowrap
// }
 .price_title[data-v-951e5bd4] {
    height: 20px;
    font-size: 20px;
    font-family: PingFang SC;
    font-weight: 700;
    color: #2c2c2c;
    text-align: center;
    line-height: 20px;
    margin: 30px auto;
    background-image: url(data:image/png;base64,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);
    background-position-y: center;
    background-position-x: center;
    background-repeat: no-repeat;
}
</style>
